var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	5724: {
		fallback: function() { return function() { return __webpack_require__(5723); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react/jsx-runtime",
	},
	2760: {
		fallback: function() { return Promise.all([__webpack_require__.e(195), __webpack_require__.e(1550), __webpack_require__.e(894), __webpack_require__.e(5724), __webpack_require__.e(3517), __webpack_require__.e(3041)]).then(function() { return function() { return __webpack_require__(3144); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",
	},
	1381: {
		fallback: function() { return __webpack_require__.e(4160).then(function() { return function() { return __webpack_require__(1779); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	1685: {
		fallback: function() { return Promise.all([__webpack_require__.e(195), __webpack_require__.e(317)]).then(function() { return function() { return __webpack_require__(317); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	7995: {
		fallback: function() { return Promise.all([__webpack_require__.e(1550), __webpack_require__.e(3517), __webpack_require__.e(6664)]).then(function() { return function() { return __webpack_require__(8474); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	},
	5029: {
		fallback: function() { return Promise.all([__webpack_require__.e(3188), __webpack_require__.e(3517), __webpack_require__.e(4292)]).then(function() { return function() { return __webpack_require__(3188); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",
	},
	4813: {
		fallback: function() { return __webpack_require__.e(1986).then(function() { return function() { return __webpack_require__(6748); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	9065: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(2155); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",
	},
	7438: {
		fallback: function() { return __webpack_require__.e(8765).then(function() { return function() { return __webpack_require__(8765); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",
	},
	9787: {
		fallback: function() { return __webpack_require__.e(368).then(function() { return function() { return __webpack_require__(368); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",
	},
	3134: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(8997); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",
	},
	3517: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(316); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",
	},
	1172: {
		fallback: function() { return __webpack_require__.e(4367).then(function() { return function() { return __webpack_require__(6748); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	376: {
		fallback: function() { return Promise.all([__webpack_require__.e(195), __webpack_require__.e(317), __webpack_require__.e(8426)]).then(function() { return function() { return __webpack_require__(317); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	7088: {
		fallback: function() { return __webpack_require__.e(4160).then(function() { return function() { return __webpack_require__(1779); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	1684: {
		fallback: function() { return __webpack_require__.e(3188).then(function() { return function() { return __webpack_require__(3188); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",
	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [5724,2760,1381,1685,7995,5029,4813,9065,7438,9787,5724,9065,3134,3517,7088,2760,1684,1172,376];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"636": [
		7088,
		2760,
		1684,
		1172,
		376
	],
	"1172": [
		1172
	],
	"2631": [
		376
	],
	"2760": [
		2760
	],
	"3517": [
		3517
	],
	"5527": [
		1381,
		1685,
		7995,
		5029,
		4813,
		9065,
		7438,
		9787
	],
	"5724": [
		5724
	],
	"8792": [
		5724,
		9065,
		3134,
		3517
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}